/**
 * External dependencies.
 */
import { assign } from 'lodash';

/**
 * Internal dependencies.
 */
import { getPaddingMarginCss, updateBlock, addStyleTag } from '../../extensions/custom-styles';

function styling( props, selector = false, attributes = false ) {
	const { blockAdvanceOptions, prefixFontSize, titleFontSize, suffixFontSize } = attributes ? attributes : props.attributes;
	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId }`;

	css += getPaddingMarginCss( blockAdvanceOptions, selector );

	css += `${ selector } .gutenify-section-title-prefix{
		${ prefixFontSize ? `font-size: ${ prefixFontSize }` : '' };
	}`;
	css += `${ selector } .gutenify-section-title-main{
		${ titleFontSize ? `font-size: ${ titleFontSize }` : '' };
	}`;
	css += `${ selector } .gutenify-section-title-suffix{
		${ suffixFontSize ? `font-size: ${ suffixFontSize }` : '' };
	}`;

	return css;
}

const updateBlockStyle = ( data, props ) => {
	const attrs = assign( props.attributes, data );
	const css = styling( props, false, attrs );

	updateBlock( data, css, props );

	// Admin.
	const adminCss = styling( props, `#block-${ props.clientId }` );
	addStyleTag( props, adminCss, `gutenify-block-${ props.clientId }-main`, true );
};

export { updateBlockStyle };
export default styling;
